import { Box, Typography, IconButton, useTheme, Link } from "@mui/material";
import { GitHub, LinkedIn, Email } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom"; // Importa Link da react-router-dom

function linkOutlinkedIn() {
  window.location.href = "https://www.linkedin.com/in/developerandrearicci";
}

function linkOutGitHub() {
  window.location.href = "https://github.com/Riccio9";
}

function linkInContacts() {
  window.location.pathname = "/contact";
}

export default function Footer() {
  const theme = useTheme(); // Ottiene il tema attuale

  return (
    <Box
      sx={{
        textAlign: "center",
        py: 2,
        bgcolor: theme.palette.mode === "dark" ? "grey.900" : "rgb(25, 118, 210)", // Scuro in dark mode, blu in light mode
        color: "white",
      }}
    >
      <Typography variant="body2">
        © 2026 Andrea Ricci |{" "}
        <Link
          component={RouterLink}
          to="/privacy-policy"
          color="inherit"
          underline="always"
        >
          Privacy Policy
        </Link>
      </Typography>
      <Box mt={1}>
        <IconButton color="inherit" onClick={linkOutGitHub}>
          <GitHub />
        </IconButton>
        <IconButton color="inherit" onClick={linkOutlinkedIn}>
          <LinkedIn />
        </IconButton>
        <IconButton color="inherit" onClick={linkInContacts}>
          <Email />
        </IconButton>
      </Box>
      <Typography variant="caption" display="block" mt={1}>
        Realizzato con React, Material-UI.
      </Typography>
    </Box>
  );
}
